import { useTranslation } from "react-i18next";

import { cx, styled } from "simplydo/react/styled";
import { Message } from "simplydo/react/ui";

const StyledMessageItem = styled(Message.Item)`
  &.is-invalid {
    color: #cc202d;
  }
`;

const PasswordGuidance = ({ password = "" }) => {
  const { t } = useTranslation();
  return (
    <Message>
      <Message.Header>
        {t("entry.register.passwordGuidance.title")}
      </Message.Header>
      <Message.List>
        <StyledMessageItem
          className={cx(
            password.length > 0 && password.length < 8 && "is-invalid",
          )}
        >
          {t("entry.register.passwordGuidance.passwordLimit")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.noRepeat")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.manager")}
        </StyledMessageItem>
      </Message.List>
    </Message>
  );
};

export default PasswordGuidance;
